import { render, staticRenderFns } from "./CapturaDocumentosTipo.vue?vue&type=template&id=1141f456&scoped=true&"
import script from "./CapturaDocumentosTipo.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosTipo.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosTipo.vue?vue&type=style&index=0&id=1141f456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1141f456",
  null
  
)

export default component.exports